var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('header',[_c('b-navbar',{staticClass:"border-bottom box-shadow mb-3",attrs:{"type":"light"}},[_c('b-container',[_c('b-navbar-brand',{attrs:{"href":"#"}},[_vm._v("Contractor Portal")])],1)],1)],1),_c('b-container',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }